let usage = `
<Collapser :opened.sync="openCollapser" :label="label">
  <h3>We are the stewards of the hierarchy</h3>
</Collapser>
`.slice(1);

export default {
  usage
};
